import { useChecklist } from '@tour-kit/checklists';
import { useEffect } from 'react';

import {
  GET_STARTED_CHECKLIST_ID,
  GET_STARTED_TASK,
} from '@/core/guidance/constants';
import { useGuidanceStore } from '@/core/guidance/guidance.store';

type ChecklistHintGateSyncProps = {
  /** Persisted personal share flag (user × workspace). */
  shareDone: boolean;
};

/** Publishes share-done for hints without coupling Hints to ChecklistProvider. */
export function ChecklistHintGateSync({
  shareDone: shareDonePersisted,
}: ChecklistHintGateSyncProps) {
  const setChecklistHintGate = useGuidanceStore((s) => s.setChecklistHintGate);
  const { tasks, exists } = useChecklist(GET_STARTED_CHECKLIST_ID);

  useEffect(() => {
    if (!exists) {
      setChecklistHintGate({ shareDone: shareDonePersisted });
      return;
    }

    const shareDone =
      shareDonePersisted ||
      tasks.some(
        (task) => task.config.id === GET_STARTED_TASK.meShare && task.completed,
      );

    setChecklistHintGate({ shareDone });
  }, [exists, tasks, shareDonePersisted, setChecklistHintGate]);

  useEffect(() => {
    return () => {
      setChecklistHintGate({ shareDone: false });
    };
  }, [setChecklistHintGate]);

  return null;
}
